import { TYPOGRAPHY_COLORS } from 'constants/TypographyColors'
import { SVGIcon } from './SvgIcon/SvgIcon'
import { IconProps } from './types'

export const DocumentsIcon = ({
  size,
  color = 'grey400',
  className,
}: IconProps) => (
  <SVGIcon size={size} color={color} className={className} viewBox="0 0 20 20">
    <path
      d="M8.75 1.25V5.25C8.75 5.51522 8.64464 5.76957 8.45711 5.95711C8.26957 6.14464 8.01522 6.25 7.75 6.25H3.75"
      stroke={TYPOGRAPHY_COLORS[color]}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M5.53571 18.75H14.4643C14.9379 18.75 15.3921 18.5451 15.727 18.1805C16.0619 17.8158 16.25 17.3213 16.25 16.8056V3.19444C16.25 2.67875 16.0619 2.18417 15.727 1.81951C15.3921 1.45486 14.9379 1.25 14.4643 1.25H8.21429L3.75 6.11111V16.8056C3.75 17.3213 3.93814 17.8158 4.27302 18.1805C4.60791 18.5451 5.06211 18.75 5.53571 18.75Z"
      stroke={TYPOGRAPHY_COLORS[color]}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SVGIcon>
)
